var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4714 3.52827C8.21106 3.26792 7.78894 3.26792 7.5286 3.52827L4.19526 6.8616C3.93491 7.12195 3.93491 7.54406 4.19526 7.80441C4.45561 8.06476 4.87772 8.06476 5.13807 7.80441L8 4.94248L10.8619 7.80441C11.1223 8.06476 11.5444 8.06476 11.8047 7.80441C12.0651 7.54406 12.0651 7.12195 11.8047 6.8616L8.4714 3.52827ZM11.8047 11.5283L8.4714 8.19494C8.21106 7.93459 7.78894 7.93459 7.5286 8.19494L4.19526 11.5283C3.93491 11.7886 3.93491 12.2107 4.19526 12.4711C4.45561 12.7314 4.87772 12.7314 5.13807 12.4711L8 9.60915L10.8619 12.4711C11.1223 12.7314 11.5444 12.7314 11.8047 12.4711C12.0651 12.2107 12.0651 11.7886 11.8047 11.5283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/up-icon.ebb817551a9fcd0fec9d3aec003d9ef4.svg";
export { ForwardRef as ReactComponent };